import FileEditComponent from '@/components/FileEditComponent/FileEditComponent';
import ThreeDViewer from '@/components/FileViewers/3dViewer/ThreeDViewer';
import CSVViewer from '@/components/FileViewers/CSVViewer/CSVViewer';
import DefaultFilePreview from '@/components/FileViewers/DefaultFilePreview/DefaultFilePreview';
import PDFViewer from '@/components/FileViewers/PDFViewer/PDFViewer';
import AudioPlayer from '@/components/FileViewers/Player/AudioPlayer';
import VideoPlayer from '@/components/FileViewers/Player/VideoPlayer';
import XLSXViewer from '@/components/FileViewers/XLSXViewer/XLSXViewer';
import { IFileTabsProps } from 'interfaces/PreviewScreen/previewScreen';
import editIcon from 'public/assets/edit.svg';

import TextFileViewer from '../../FileViewers/TextFileViewer/TextFileViewer';

const FileTab = ({
  fileResponse,
  setIsEditClicked,
  setIsLexical,
  isEditClicked,
  isLexical,
  getFile,
  setErrorPage,
}: IFileTabsProps) => {
  const mimetype = fileResponse?.data.mimetype?.substring(0, 5);

  function renderComponent() {
    if (
      (fileResponse.data.mimetype === 'application/octet-stream' &&
        (fileResponse.data.name.includes('.glb') ||
          fileResponse.data.name.includes('.gltf'))) ||
      ['gltf', 'glb'].includes(fileResponse.data?.extension)
    ) {
      return <ThreeDViewer url={fileResponse.data.url} />;
    }
    if (fileResponse.data.mimetype === 'application/pdf')
      return (
        <div className=" h-full w-full flex flex-col overflow-auto justify-center bg-[#333739]">
          <PDFViewer url={fileResponse.data.url} />
        </div>
      );

    if (
      fileResponse.data.mimetype === 'application/json' ||
      fileResponse.data.name.split('.').pop() === 'md'
    )
      return (
        <div className="w-full h-full overflow-y-auto">
          <TextFileViewer
            fileData={fileResponse.data}
            setIsLexical={setIsLexical}
            isEditClicked={isEditClicked}
            setIsEditClicked={setIsEditClicked}
          />
        </div>
      );

    if (fileResponse.data.mimetype === 'text/csv')
      return (
        <div className="w-full h-full">
          <CSVViewer url={fileResponse.data.url} />
        </div>
      );

    if (fileResponse.data?.extension === 'xlsx')
      return <XLSXViewer fileResponse={fileResponse} />;

    if (mimetype === 'audio')
      <div className="w-full h-full">
        <AudioPlayer
          url={fileResponse.data.url}
          mimetype={fileResponse.data.mimetype}
        />
      </div>;
    if (mimetype === 'image')
      return (
        <div className="w-full h-full flex p-4 justify-center items-center">
          <img
            src={fileResponse.data.url} // quick fix add a 404 image
            alt={fileResponse.data.name}
            className="rounded-[6px]  max-h-full "
          />
        </div>
      );

    if (mimetype === 'video')
      return (
        <VideoPlayer
          url={fileResponse.data.url}
          mimetype={fileResponse.data.mimetype}
        />
      );

    return <DefaultFilePreview fileResponse={fileResponse} />;
  }

  return (
    <div className={`h-full  relative`}>
      <div
        className="absolute top-0 right-0 p-2 bg-[#F6F5F3] cursor-pointer"
        onClick={(e) => {
          e.stopPropagation();
          return setIsEditClicked(!isEditClicked);
        }}
        style={{ display: 'none' }}
      >
        <img src={editIcon.src} alt="edit file" />
      </div>

      {isEditClicked && !isLexical ? (
        <FileEditComponent
          getFile={getFile}
          setIsEditClicked={setIsEditClicked}
          setErrorPage={setErrorPage}
        />
      ) : (
        <section className="h-full flex justify-center items-center w-full box-border lg:col-span-2">
          {renderComponent()}
        </section>
      )}
    </div>
  );
};

export default FileTab;
